module.exports = __webpack_public_path__ + "img/37.7e4fa6e6.jpg";